/**
 * @description 定时任务列表表格列头配置
 * @returns {Array} 表格列配置数组
 */
export default function () {
  /* 表格列头配置 */
  return [
    // 序号列
    { label: "序号", type: "index", width: 80 },

    { label: "任务名称", prop: "task_name", width: 150, slots: "task_name", },

    // 所属公众号
    { label: "所属公众号", prop: "account_name", width: 150, },

    // 公众号用户openid
    // { label: "公众号用户openid", prop: "gzh_openid", slots: "gzh_openid", width: 300 },

    // 消息模版
    { label: "模版", prop: "template_id", slots: "template_id", minWidth: 150 },

    // 时间周期
    { label: "时间周期", prop: "cycle_id", width: 120, slots: "cycle_id" },

    { label: "发送状态", prop: "status", width: 120, slots: "status" },

    // 创建时间
    {
      label: "创建时间",
      prop: "create_time",
      width: 180
    },

    // 操作列
    {
      label: "操作",
      prop: "operation",
      width: 100,
      slots: "operation",
      fixed: "right"
    }
  ];
}
